/**
 * Created by liux on 2017/12/27.
 * @param url String
 * 使用 iframe 打开一个指定协议
 */

function openJsBridge(src) {
  var iframe = document.createElement('iframe');
  iframe.src = src;
  iframe.setAttribute('style','position:absolute;z-index:-1;left:0;bottom:0;width:0;height:0;opacity:0;border:none;');
  iframe.frameborder = 0;
  var body = document.getElementsByTagName('body')[0];
  body.appendChild(iframe);
  setTimeout(() => {
    body.removeChild(iframe);
  }, 1000);
}

export default openJsBridge